import BaseRequest from '@/qingyu/request/base'
import { config } from '@/qingyu'

/**
 * 提报相关API请求类
 */
export default class ReportRequest extends BaseRequest {
  // 获取提报列表
  getReportList(params) {
    return this.get('/report/list', params)
  }
  
  // 获取提报详情
  getReportDetail(id) {
    return this.get(`/report/detail/${id}`)
  }
  
  // 创建提报
  createReport(data) {
    return this.post('/report/create', data)
  }
  
  // 取消提报
  cancelReport(id) {
    return this.post(`/report/cancel/${id}`)
  }
  
  // 上传附件
  uploadAttachment(file, onProgress) {
    const formData = new FormData()
    formData.append('file', file)
    
    return this.post('/report/upload', formData, false, {
      'Content-Type': 'multipart/form-data',
      onUploadProgress: progressEvent => {
        if (onProgress && progressEvent.total > 0) {
          onProgress(progressEvent.loaded / progressEvent.total * 100)
        }
      }
    })
  }
  
  // 获取提报类型列表
  getReportTypes() {
    return this.get('/report/types')
  }
  
  // 获取部门列表
  getDepartments() {
    return this.get('/report/departments')
  }
  
  // 追加提报内容
  appendReport(id, data) {
    return this.post(`/report/append/${id}`, data)
  }
  
  // 删除附件
  deleteAttachment(id) {
    return this.delete(`/report/attachment/${id}`)
  }
} 